/**
 * Guard 인증 체크 중 표시되는 전체화면 로더
 * GuestGuard / AuthGuard / RoleGuard 공통 사용
 *
 * 프로젝트 디자인에 맞게 스피너 교체 가능
 */
export function FullscreenLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50">
      <div className="flex flex-col items-center gap-3">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-primary" />
        <p className="text-sm text-slate-400">로딩 중...</p>
      </div>
    </div>
  );
}
